module.exports = __webpack_public_path__ + "img/home.e46b0b1c.png";